import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import Logo from './Logo';
import SocialIcons from './SocialIcons';
import { useLang } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-white/10 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-5 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <Logo />
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 font-cond tracking-[0.2em] text-white/50 text-sm">
            <span>ENERGY</span><span className="text-[#ff2d2d]">·</span>
            <span>CONFIDENCE</span><span className="text-[#ff2d2d]">·</span>
            <span>PERFORMANCE</span><span className="text-[#ff2d2d]">·</span>
            <span>EVERYDAY</span>
          </div>
          <SocialIcons />
        </div>

        <div className="mt-10 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
          <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
            <Link to="/about" className="hover:text-white">{t('about')}</Link>
            <Link to="/ingredients" className="hover:text-white">{t('ingredients')}</Link>
            <Link to="/flavours" className="hover:text-white">{t('flavours')}</Link>
            <Link to="/faq" className="hover:text-white">{t('faq')}</Link>
            <Link to="/managers" className="hover:text-white">{t('managers')}</Link>
          </div>
          <div className="flex items-center gap-1.5 font-script text-lg text-white/60">
            <Zap className="w-4 h-4 text-[#ff2d2d]" fill="#ff2d2d" /> A bolder you.
          </div>
        </div>
        <p className="mt-6 text-center text-xs text-white/30 max-w-3xl mx-auto">
          Food supplement. Not a substitute for a varied and balanced diet or a healthy lifestyle. Keep out of reach of young children. © {new Date().getFullYear()} S-MAN.
        </p>
      </div>
    </footer>
  );
}
